import React, { Component } from 'react';
import Boutons from './Boutons';

class UnAvis extends Component {

    constructor (props){
        super (props);
        this.state = {
            revenu: 0,
            parts: 0,
        }
    }

    action (item,valeur) {
        const { callback } = this.props;
        
        switch (item){
            case "revenu1":
                this.setState({revenu : valeur});
                break;
            case "parts1":
                this.setState ({parts: valeur});
                break;
            default:
                break;
        }

        callback({ type: item, valeur: valeur});
    }

    estValide(){
        const { revenu, parts } = this.state;
        let valide = false;

        if (( revenu !== "") && (parts !== "")) valide = true;
        if (( revenu === "") || (parts === "") ) valide = false;

        return valide;
    }

    render (){
        const {revenu, parts, callback} = this.props; 

        let montant = revenu.toString();
        if (montant === "0") montant = "";

        let nbParts = parts.toString();
        if (nbParts === "0") nbParts = "";

        return (
            <div className="container unAvis" style={{ width: "100%"}}>
                <h2>3- Conditions de revenu</h2>
                <div className="intro">
                    <p id="intro" style={{ fontSize: "14px" }}>Votre participation est déterminée en fonction des revenus de la famille. Vous trouverez sur votre avis d'imposition le revenu fiscal de référence ainsi que le nombre de parts. Merci de les reporter ci-dessous :</p>
                </div>
                <div className="row" style={{ marginLeft: "30px"}}>
                    <label htmlFor="revenu1" className="col-3" style={{width: "150px"}}>Revenu fiscal de référence :</label>
                    <input type="number" className="form-control-plaintext col-8" id="revenu1" placeholder="figurant sur l'avis" defaultValue={montant} onChange={ (valeur) => this.action("revenu1", valeur.target.value) }/> €
                </div>    
                <div className="row" style={{ marginLeft: "30px"}}>
                    <label htmlFor="parts1" className="col-3"  style={{width: "150px"}}>Nombre de parts :</label>
                    <input type="number" min="0" step="0.25" className="form-control-plaintext col-8" id="parts1" placeholder="figurant sur l'avis" defaultValue={nbParts} onChange={ (valeur) => this.action("parts1", valeur.target.value)} /> 
                </div>
                <Boutons retour="situation" suivant="resultat" valide={this.estValide()} callback={callback}/>
            </div>
        )
    }
}

export default UnAvis;